export const LOGIN = 'LOGIN';
export const SET_ABILITY = 'SET_ABILITY';
export const LOGOUT = 'LOGOUT';
